import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LandingPageRoutingModule } from './landing-page-routing.module';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { CardDesktopComponent } from './card-desktop/card-desktop.component';
import { CardMobileComponent } from './card-mobile/card-mobile.component';
import { PageBodyComponent } from './page-body/page-body.component';
import { PageButtonComponent } from './page-button/page-button.component';
import { PageCardComponent } from './page-card/page-card.component';
import { PageFeatureComponent } from './page-feature/page-feature.component';
import { PageGalleryComponent } from './page-gallery/page-gallery.component';
import { PageHeadingComponent } from './page-heading/page-heading.component';
import { PageHowToComponent } from './page-how-to/page-how-to.component';
import { PageImageDropperComponent } from './page-image-dropper/page-image-dropper.component';
import { PageServiceComponent } from './page-service/page-service.component';
import { PageSpacerComponent } from './page-spacer/page-spacer.component';
import { BreadcrumbComponent, BreadcrumbItemDirective } from "xng-breadcrumb";
import { SidebarModule } from '../sidebar/sidebar.module';
import { GeneralModule } from '../general/general.module';
import { OddsDisclaimerComponent } from '../general/odds-disclaimer/odds-disclaimer.component';


@NgModule({
  declarations: [
	LandingPageComponent,
	CardDesktopComponent,
	CardMobileComponent,
	PageBodyComponent,
	PageButtonComponent,
	PageCardComponent,
	PageFeatureComponent,
	PageGalleryComponent,
	PageHeadingComponent,
	PageHowToComponent,
	PageImageDropperComponent,
	PageServiceComponent,
	PageSpacerComponent
  ],
  imports: [
	CommonModule,
	LandingPageRoutingModule,
	BreadcrumbComponent,
	BreadcrumbItemDirective,
	SidebarModule,
	GeneralModule,
	OddsDisclaimerComponent,
  ]
})
export class LandingPageModule { }
